import { motion } from "framer-motion";
import { Check } from "lucide-react";
import { IMAGES } from "@/data/site";

const specs = [
  { k: "Modèle", v: "Peugeot 508 SW" },
  { k: "Motorisation", v: "Hybrid 180 e-EAT8" },
  { k: "Finition", v: "Allure — Année 2025" },
  { k: "Couleur", v: "Blanc Nacré" },
];

const features = ["4 passagers", "Grands bagages", "Climatisation tri-zone", "Eau & chargeurs offerts", "Sièges confort", "Conduite hybride silencieuse"];

export default function VehicleShowcase() {
  return (
    <section id="vehicle" data-testid="vehicle" className="bg-[#0B132B] grain relative py-24 md:py-36 overflow-hidden">
      <div className="relative z-10 mx-auto max-w-[1400px] px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 items-center">
          <motion.div
            initial={{ opacity: 0, x: -40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
          >
            <span className="text-xs tracking-[0.35em] uppercase text-[#8ea2c8]">Le véhicule</span>
            <h2 className="font-display text-4xl md:text-6xl text-white leading-[1.02] tracking-tight mt-5">
              Peugeot 508 SW<br /><span className="italic text-[#8ea2c8]">Hybrid 180</span>
            </h2>
            <p className="text-white/65 leading-relaxed mt-6 max-w-lg">
              Une berline break haut de gamme, hybride et immaculée. Design i-Cockpit, habitacle spacieux et roulage électrique silencieux pour un confort absolu sur chaque trajet.
            </p>

            <div className="grid grid-cols-2 gap-px bg-white/10 mt-10 border border-white/10">
              {specs.map((s) => (
                <div key={s.k} className="bg-[#0B132B] p-5">
                  <div className="text-[11px] uppercase tracking-widest text-[#8ea2c8]">{s.k}</div>
                  <div className="text-white font-semibold mt-1.5">{s.v}</div>
                </div>
              ))}
            </div>

            <div className="grid grid-cols-2 gap-y-3 gap-x-6 mt-8">
              {features.map((f) => (
                <div key={f} className="flex items-center gap-2.5 text-white/80 text-sm">
                  <Check className="w-4 h-4 text-[#8ea2c8] shrink-0" strokeWidth={2.5} />
                  {f}
                </div>
              ))}
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, scale: 0.96 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
            className="relative"
          >
            <div className="absolute -inset-4 bg-[#1C2541] blur-2xl opacity-40" />
            <img src={IMAGES.side} alt="Peugeot 508 SW profil" className="relative w-full object-cover border border-white/10" />
            <img src={IMAGES.interior} alt="Intérieur Peugeot 508" className="relative -mt-16 ml-auto w-2/3 object-cover border-4 border-[#0B132B] shadow-2xl" />
          </motion.div>
        </div>
      </div>
    </section>
  );
}
